import { h, render } from 'preact';
import { useEffect } from 'preact/hooks';
import htm from 'htm';
import { AppLayout } from './components/AppLayout.js';
import { AppContent } from './components/AppContent.js';
import { initApp } from './logic/app-init.js';

const html = htm.bind(h);

function Root() {
    useEffect(() => {
        initApp();
    }, []);

    return html`
        <${AppLayout}>
            <${AppContent} />
        </${AppLayout}>
    `;
}

const root = document.getElementById('app');
if (root) {
    render(html`<${Root} />`, root);
}
